var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rtl"},[_c('vue-header',{attrs:{"IsScroll":_vm.$route.name == 'index'}}),_c('transition',{attrs:{"enter-active-class":"animated fade"}},[_c('router-view')],1),_c('vue-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }